export default class NetworkError implements Error {
  name: string = 'NetworkError';
  message: string = 'Unexpected network error occured.';
}
